import type { GameMeta } from "../../common/gameMeta.js";
import type { TurfWarVariantConfig } from "./variantConfig.js";

export const meta = {
	name:        "Turf War",
	minPlayers:  2,
	maxPlayers:  6,
	description: "Claim territory, control regions, dominate the map.",
	instructions: `
Each player starts with a small spawn cluster in a corner.
Tap any tile adjacent (or diagonal) to your territory to claim it.
The more tiles you own, the faster your cooldown refills.
Control every tile in a region for a speed bonus!
You can steal enemy tiles — but not their spawn.
Most tiles + completed regions when time runs out wins.
	`.trim(),
	mobileBrowserCompatible: true,
	showScores: false,
	modifiers: [
		{
			id:           "blitz",
			label:        "Blitz",
			instructions: "45 seconds, no region bonuses — pure aggression.",
			config: { blitz: true, fogOfWar: false } satisfies TurfWarVariantConfig,
		},
		{
			id:           "fog",
			label:        "Fog of War",
			instructions: "You can only see your own tiles and immediate neighbours. Enemy territory is hidden.",
			config: { blitz: false, fogOfWar: true } satisfies TurfWarVariantConfig,
		},
	],
} satisfies GameMeta;
